import axios from '@/api/axios';

// System announcements ("Co nowego") published by Pagaspot for the staff of every
// organisation. Read state is per user; the count drives the bell, the "Co nowego"
// tab and the "Wiadomości" menu badge.
export default {
  state: {
    unreadNews: 0,
  },
  mutations: {
    setUnreadNews(state, count) {
      state.unreadNews = count;
    },
  },
  getters: {
    unreadNews: (s) => s.unreadNews,
  },
  actions: {
    async getUnreadNews({ commit }) {
      try {
        const { data } = await axios.get('user/news/unread-count');
        commit('setUnreadNews', data.count || 0);
      } catch {
        commit('setUnreadNews', 0);
      }
    },
    async getNews({ commit }, params = {}) {
      const { data } = await axios.get('user/news', { params: { query: params } });
      if (!params.unreadOnly && !params.category) {
        commit('setUnreadNews', data.unreadCount || 0);
      }
      return data;
    },
    async getNewsItem(context, postId) {
      const { data } = await axios.get(`user/news/${postId}`);
      return data;
    },
    async getNewsPopup() {
      const { data, status } = await axios.get('user/news/popup');
      return status === 204 ? null : data;
    },
    async openNews({ dispatch }, postId) {
      await axios.post(`user/news/${postId}/open`);
      dispatch('getUnreadNews');
    },
    async dismissNews(context, postId) {
      await axios.post(`user/news/${postId}/dismiss`);
    },
    async sendNewsFeedback(context, { postId, helpful }) {
      await axios.post(`user/news/${postId}/feedback`, { helpful });
    },
    async markAllNewsRead({ commit }) {
      await axios.post('user/news/mark-all-read');
      commit('setUnreadNews', 0);
    },
  },
};
